import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from '../../../../environments/environment';
const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class IbanRegionService {
  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public saveIbanRegion(data: any, userId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'iban-region/IbanRegion/saveIbanRegion',
        { data, addedBy: userId },
        { headers });
  }

  public updateIbanRegion(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'iban-region/IbanRegion/updateIbanRegion',
        { data },
        { headers });
  }

  public getIbanRegions(search: string) {
    const params = new  HttpParams()
      .set('_search', search);

    return this.httpClient.get(this.SERVER_URL + 'iban-region/IbanRegion/getIbanRegions', {params});
  }

  public deleteIbanRegion(ibanRegionId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'iban-region/IbanRegion/deleteIbanRegion',
        { ibanRegionId },
        { headers });
  }
}